<template>
  <div class="user">
    <div class="user_img">
      <img :src="joinerImg" alt v-if="joinerImg" />
      <img alt src="../../../../ui/LianPoH5/images/default_img.png" v-else />
    </div>
    <div
      class="user_name"
    >{{ decodeURIComponent(decodeURIComponent(joinerItem.nick_name)) || "王者峡谷召唤师" }}</div>
  </div>
</template>

<script>
export default {
  name: "JoinerItem",
  props: ["joinerItem"],
  computed: {
    joinerImg() {
      let joinerImg = ""
      try {
        let preImgUrl = decodeURIComponent(decodeURIComponent(this.joinerItem.img_url)).replace("http://", "https://")
        if (preImgUrl) joinerImg = preImgUrl
      } catch (error) {
        console.log(error)
      }
      return joinerImg
    }
  }
}
</script>

<style scoped>
.user .user_name {
  line-height: 0.6rem;
}
</style>
